<script setup lang="ts">
interface Props {
  isOpen: boolean
  title: string
  pdfUrl: string
  modalId?: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  close: []
  download: [url: string]
}>()

const { t } = useI18n()

function closeModal() {
  emit('close')
}

const pdfViewerUrl = computed(() => {
  if (!props.pdfUrl)
    return ''
  return props.pdfUrl
})
</script>

<template>
  <SolModal
    :id="modalId ?? 'pdf-preview'"
    :is-open="isOpen"
    :title="title"
    :size=" {
      desktop: 'large',
      mobile: 'full',
    }"
    @close="closeModal"
  >
    <template #default>
      <div class="pdf-preview-container">
        <div class="pdf-preview-content">
          <iframe
            v-if="pdfViewerUrl"
            :src="pdfViewerUrl"
            class="pdf-iframe"
            :title="t('fileUpload.preview.title')"
            frameborder="0"
          />
          <div v-else class="pdf-error">
            <p>{{ t('fileUpload.preview.loadError') }}</p>
          </div>
        </div>
      </div>
    </template>
  </SolModal>
</template>

<style scoped lang="scss">
.pdf-preview-container {
  @apply flex flex-col h-full;
  @apply max-h-screen;

  .pdf-preview-content {
    @apply flex-1 overflow-hidden;
    @apply min-h-96;

    .pdf-iframe {
      @apply w-full h-full;
      @apply min-h-96;
      @apply rounded-md;
    }

    .pdf-error {
      @apply flex flex-col items-center justify-center;
      @apply h-96;
      @apply bg-neutral-high-light;
      @apply rounded-md;
      @apply gap-md;
    }
  }
}
</style>
